const customDetailStyle = {
  menuList: () => ({
    width: "100%",
    maxHeight: "100px",
    overflowY: "auto",
  }),
};

export default customDetailStyle;
